import React from "react";

import { composeValidators, validateHundred, validateNumber, validateRequired, validateZero } from "Utils/Validations";

import { MULTIPLE_PLAN_CONTRIBUTION_TYPES } from "Common/Constants";
import { SIFinalFormFieldNoCol } from "Common/forms";
import { Input as SIFormInput } from "Theme/Input";
import { Select as SIFormSelect } from "Theme/Select";

export const ContributionNameNoCol = ({ namePrefix = "", ...rest }) => (
  <SIFinalFormFieldNoCol name={`${namePrefix}.name`} label="Contribution Name" component={SIFormInput} validate={validateRequired} {...rest} />
);

const CONTRIBUTION_TYPES_OPTIONS = Object.keys(MULTIPLE_PLAN_CONTRIBUTION_TYPES).reduce((acc, type) => {
  const key = MULTIPLE_PLAN_CONTRIBUTION_TYPES[type];
  acc[key] = type;
  return acc;
}, {});

export const ContributionTypeNoCol = ({ namePrefix = "", ...rest }) => (
  <SIFinalFormFieldNoCol
    name={`${namePrefix}.contributionType`}
    label="Contribution Type"
    component={SIFormSelect}
    componentProps={{
      options: CONTRIBUTION_TYPES_OPTIONS,
    }}
    validate={validateRequired}
    {...rest}
  />
);

export const EmployeePercentageNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol
    name={`${namePrefix}.employeePercentage`}
    label="Percentage for Employees"
    component={SIFormInput}
    componentProps={{
      appendContent: "%",
      type: "number",
      min: 0,
      max: 100,
    }}
    guidance={["Typically ", <strong key="employee-percentage">{">50%"}</strong>, " of the employee's monthly cost."]}
    validate={composeValidators(validateRequired, validateZero, validateHundred, validateNumber)}
    {...rest}
  />
);

export const DependentPercentageNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol
    name={`${namePrefix}.dependentPercentage`}
    label="Percentage for Dependents"
    component={SIFormInput}
    componentProps={{
      appendContent: "%",
      type: "number",
      min: 0,
      max: 100,
    }}
    guidance={["Typically ", <strong key="dependent-percentage">0%</strong>, " of the dependent cost. Many companies do not reimburse for dependents."]}
    validate={composeValidators(validateRequired, validateZero, validateHundred, validateNumber)}
    {...rest}
  />
);

export const EmployeeFixedAmountNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol
    name={`${namePrefix}.employeeFixedAmount`}
    label="Amount for Employees"
    component={SIFormInput}
    componentProps={{
      prependContent: "$",
      type: "number",
      min: 0,
    }}
    guidance={["Typically ", <strong key="employee-amount">half or more</strong>, " of the employee's monthly cost."]}
    validate={composeValidators(validateRequired, validateZero, validateNumber)}
    {...rest}
  />
);

export const DependentFixedAmountNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol
    name={`${namePrefix}.dependentFixedAmount`}
    label="Amount for Dependents"
    component={SIFormInput}
    componentProps={{
      prependContent: "$",
      type: "number",
      min: 0,
    }}
    guidance={["Typically ", <strong key="dependent-amount">zero</strong>, ". Many companies do not reimburse for dependents."]}
    validate={composeValidators(validateRequired, validateZero, validateNumber)}
    {...rest}
  />
);

export const MedicalContributionNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol name={`${namePrefix}.medicalCompanyContributionID`} label="Medical Company Contribution" component={SIFormSelect} {...rest} />
);

export const DentalContributionNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol name={`${namePrefix}.dentalCompanyContributionID`} label="Dental Company Contribution" component={SIFormSelect} {...rest} />
);

export const VisionContributionNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol name={`${namePrefix}.visionCompanyContributionID`} label="Vision Company Contribution" component={SIFormSelect} {...rest} />
);

export const LifeContributionNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol name={`${namePrefix}.lifeCompanyContributionID`} label="Life Company Contribution" component={SIFormSelect} {...rest} />
);

export const LongTermDisabilityContributionNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol
    name={`${namePrefix}.longTermDisabilityCompanyContributionID`}
    label="Long Term Disability Company Contribution"
    component={SIFormSelect}
    {...rest}
  />
);

export const ShortTermDisabilityContributionNoCol = ({ namePrefix = "", ...rest }: any) => (
  <SIFinalFormFieldNoCol
    name={`${namePrefix}.shortTermDisabilityCompanyContributionID`}
    label="Short Term Disability Company Contribution"
    component={SIFormSelect}
    {...rest}
  />
);
